// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2w-6";
export var headerCell = "_2w-2";
export var loadingStateContent = "_2w-8";
export var rowWrapper = "_2w-4";
export var stickyAggregationCell = "_2w-b";
export var stickyAggregationRow = "_2w-7";
export var stickyColumnCell = "_2w-a";
export var stickyColumnHeaderCell = "_2w-9";
export var table = "_2w-1";
export var virtualRowWrapper = "_2w-5";
export var virtualTableBodyFiller = "_2w-d";
export var virtualTableBodyFillerBottom = "_2w-e";
export var virtualTableContainer = "_2w-0";
export var virtualTableContainerFill = "_2w-c";
export var white = "_2w-3";